module.exports = __webpack_public_path__ + "static/media/ES-BANZEMA_Landing_page.66ae7cb3.webp";